import { render, staticRenderFns } from "./ResearchReportChartList.vue?vue&type=template&id=4e678cac&scoped=true"
import script from "./ResearchReportChartList.vue?vue&type=script&lang=js"
export * from "./ResearchReportChartList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e678cac",
  null
  
)

export default component.exports